export enum UserType {
    Guest = "Guest",
    Customer = "Customer",
    Provider = "Provider",
    Lender = "Lender",
    BPSAdmin = "BPSAdmin",
    Utility = "Utility",
}